import { useEffect, useState, useRef } from "react"

export const useIntersecting = ref => {
  const [intersecting, setIntersecting] = useState(true)
  const observer = useRef()

  useEffect(() => {
    const stickyRef = ref.current
    if (!observer.current) {
      observer.current = new IntersectionObserver(
        ([e]) => setIntersecting(e.isIntersecting),
        { rootMargin: "0px", threshold: 1.0 }
      )
    }
    if (stickyRef) {
      observer.current.observe(stickyRef)
    }
    return () => {
      if (observer.current) {
        observer.current.unobserve(stickyRef)
      }
    }
  }, [ref])

  return intersecting
}
